<template>
  <div class="banner-container">
    <img :src="franchiseLogo" class="logo" />

    <div
      class="menu-banner"
      :style="'background-image: url(\'' + franchiseBanner + '\')'"
    ></div>
  </div>
</template>
<script>
export default {
  created() {},
  computed: {
    franchiseBanner: function () {
      if (this.$franchiseBannerUrl)
        return this.$franchiseBannerUrl;
      else return process.env.VUE_APP_ONLINEORDERING_API_URL +
        '/images/platinum-online-banner.jpg';
    },
    franchiseLogo: function () {
      if (this.$franchiseLogoUrl)
        return this.$franchiseLogoUrl;
      else return process.env.VUE_APP_ONLINEORDERING_API_URL +
        '/images/platinum-logo.png';
    },
  }
};
</script>
<!-- Styles -->
<style scoped>
/* BANNER */
.banner-container {
  position: relative;
  text-align: center;
}
</style>